




















import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class Pagination extends Vue {
  @Prop({ default: 1 }) length?: number;

  @Prop({ default: 1 }) page!: number;

  @Prop({ default: 10 }) selectedPageSize!: number;

  private pageSizeOptions: number[] = [5, 10, 15, 30, 50, 100];

  pageChange(pageNumber: number) {
    this.$emit('pageChange', pageNumber);
  }

  pageSizeChange(sizeNumber: number) {
    this.$emit('pageSizeChange', sizeNumber);
  }
}
